<p-toast key="global-toast" position="top-right" />

<router-outlet></router-outlet>
